import { getStorefrontBasePath } from '../../modules/storefront/exports/Cookies';

class WindowResource {
  public basePath: string = getStorefrontBasePath() || '';

  public getBasePath(): string {
    return this.basePath;
  }
  public getOriginWithPathname(): string {
    return this.getOrigin() + window.location.pathname;
  }

  public getOrigin(): string {
    return window.location.origin + this.basePath;
  }

  public replace(path: string): void {
    window.location.replace(this.basePath + path);
  }

  public setHref(href: string): void {
    window.location.href = this.basePath + href;
  }
}

export default new WindowResource();
